export default "__VITE_ASSET__D7M$kVqV__"